import { Component, Input, OnInit } from '@angular/core';
import { NavMenuService } from '../navmenu.service';
import { LoginMenuTypeEnum } from '../_nav';
import { AuthService } from '../../../_infrastructure/classes/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../../../_importacion/solicitudes/types/enum';

@Component({
    selector: 'c-sidebar-navcustom',
    templateUrl: './sidebarnavcustom.component.html',
})
export class SidebarNavCustomComponent implements OnInit {
    @Input() navItems: Array<any>;

    private id: number;

    clicked: boolean = false;

    constructor(
        private navMenuService: NavMenuService,
        private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {}

    public ngOnInit(): void {
        // NO-OP
    }

    isTitle(navItem: any) {
        return !!navItem.title;
    }

    isHasChild(navItem: any) {
        return Object.prototype.hasOwnProperty.call(navItem, 'children') && navItem.children.length > 0;
    }

    hasAction(navItem: any) {
        return Object.prototype.hasOwnProperty.call(navItem, 'actionCode');
    }

    isVisible(navItem: any) {
        if (navItem.loginMenuType == LoginMenuTypeEnum.Always) {
            return true;
        }

        if (navItem.loginMenuType == LoginMenuTypeEnum.LoggedOut && !this.authService.isLoggedIn()) {
            return true;
        }

        return this.isVisibleLoggedIn(navItem);
    }

    isVisibleLoggedIn(navItem: any) {
        let output = this.authService.isLoggedIn() && navItem.loginMenuType != LoginMenuTypeEnum.LoggedOut;

        if (this.hasAction(navItem)) {
            const user = this.authService.getLoggedInUser();
            const actionType = this.navMenuService.getActionType(navItem.actionCode);

            if (user) {
                if (navItem.actionCode == EnumCodigosTwTcAcciones.MENU_PREVIA) {
                    output = output && this.navMenuService.currentSolicitudImportacion.EsPrevia;
                } else if (navItem.actionCode == EnumCodigosTwTcAcciones.MENU_PREVIA_EXPORTACION) {
                    output = output && this.navMenuService.currentSolicitudExportacion.EsPrevia;
                } else if (navItem.actionCode == EnumCodigosTwTcAcciones.MENU_ALEGACIONES) {
                    output = output && this.navMenuService.currentSolicitudExportacion.TieneAlegacion;
                } else {
                    output =
                        output &&
                        user!.getAction(navItem.actionCode, actionType.IdEstadoSolicitud, actionType.IdTipoSolicitud!, actionType.IdSubTipoSolicitud!).Visible;
                }
            }
        }

        if (navItem.visibleAfterSearching && navItem.children.some((s: any) => s.isImportDetail)) {
            output = output && this.navMenuService.isImportSolicitudSelected;
        }

        if (navItem.visibleAfterSearching && navItem.children.some((s: any) => s.isExportDetail)) {
            output = output && this.navMenuService.isExportSolicitudSelected;
        }

        if (navItem.visibleAfterSearching && navItem.children.some((s: any) => s.isAtestacionDetail)) {
            output = output && this.navMenuService.isAtestacionSolicitudSelected;
        }

        if (navItem.visibleAfterSearching && navItem.children.some((s: any) => s.isCpeDetail)) {
            output = output && this.navMenuService.isCpeSolicitudSelected;
        }

        return output;
    }

    getRouterLink(navItem: any) {
        if (navItem.isImportDetail) {
            return navItem.url + '/' + this.navMenuService.currentSolicitudImportacion.Id;
        }
        if (navItem.isExportDetail) {
            return navItem.url + '/' + this.navMenuService.currentSolicitudExportacion.Id;
        }
        if (navItem.isAtestacionDetail) {
            return navItem.url + '/' + this.navMenuService.currentSolicitudAtestacion.Id;
        }
        if (navItem.isCpeDetail) {
            return navItem.url + '/' + this.navMenuService.currentSolicitudCpe.Id;
        } else if (navItem.isUserDetail) {
            return navItem.url + '/' + this.authService.getLoggedInUser()!.Id.toString();
        } else {
            return navItem.url;
        }
    }
}
